//Components
import { Spinner } from 'react-bootstrap';

const ActivityLoading = () => {
    return (
        <div className="loading-container">
            <Spinner animation="border"  variant="primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>
    )
}

export default ActivityLoading;
